module.exports = __webpack_public_path__ + "img/arow-down.fb57087d.svg";